/**
 * UTC 날짜 문자열을 KST (한국 표준시)로 변환하여 ISO 8601 형식으로 반환
 * @param utcDateString UTC 형식의 날짜 문자열 (e.g., "2024-12-01T00:00:00Z")
 * @returns KST 시간으로 변환된 ISO 날짜 문자열 (e.g., "2024-12-01T09:00:00+09:00")
 */
export function convertUTCtoKST(utcDateString: string): string {
  // UTC 문자열을 Date 객체로 변환
  const utcDate = new Date(utcDateString);

  // UTC 시간에 9시간(9 * 60 * 60 * 1000ms)을 더함
  const kstOffset = 9 * 60 * 60 * 1000;
  const kstDate = new Date(utcDate.getTime() + kstOffset);

  // UTC +09:00 시간대임을 붙여서 표현
  return kstDate.toISOString().replace('Z', '+09:00');
}
